import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PortletSpinner from '../../../partials/layout/PortletSpinner';
import ContractSidePanel from "../Contract/ContractSidePanel";
import { connect } from "react-redux";
import * as contractDuck from "../../../store/ducks/contract.duck";

import Dashboard from '../../contract/dashboard2';
import GenericDrafts from '../../contract/GenericDrafts';
import HealthReport from '../../contract/reports/health';
import RagDashboard from '../../contract/reports/rag';

import ContractSettingsRouter from './ContractSettingsRouter';
import { withRouter } from '../../../shared/hoc/withRouter';
import Protector from "../../../router/Protector/Protector";
import NavigateToDefault from "../../../router/NavigateToDefault";
import TemplateHelper from "../../../Templates/TemplateHelper";

const styles = {
    contractLayout: {
        width: '100%',
    },
    contractMain: {
        width: '100%',
        minWidth: 0,
    },
    contractSidePanel: {
        display: 'none',
    }
};

class ContractRouter extends React.Component {
    componentDidMount() {
        this.props.loadContract(this.props.params.contractid);
    }

    componentWillUnmount() {
        this.props.unloadContract();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps && prevProps.params.contractid !== this.props.params.contractid) {
            this.props.loadContract(this.props.params.contractid);
        }
    }

    render() {
        if (!this.props.contract ||
            !this.props.contractTemplate ||
            !this.props.contractTemplate.workflowGroups ||
            !this.props.contractUser ||
            !this.props.contractUsers ||
            !this.props.contractDashboard ||
            this.props.contract.contractid !== Number(this.props.params.contractid)
        ) {
            return (<PortletSpinner />);
        }

        return (
            <div className="fd-contract-layout" style={styles.contractLayout}>
                <div className="fd-contract-main" style={styles.contractMain}>
                    <Routes caseSensitive>
                        <Route path="/" element={<Navigate to="dashboard" />} sensitive />

                        <Route
                            path="/issue-for-acceptance/*"
                            element={<Navigate replace to={this.props.location.pathname.replace('issue-for-acceptance', 'submissions')} />}
                        />

                        <Route
                            path="/dashboard"
                            element={<Protector><Dashboard key={"DynamicDashboard" + this.props.dashboardCurrencyCode} /></Protector>}
                            sensitive
                        />

                        <Route
                            path="/generic-drafts"
                            element={<Protector><GenericDrafts /></Protector>}
                            sensitive
                        />

                        <Route
                            path="/settings/*"
                            element={<ContractSettingsRouter />}
                            sensitive
                        />

                        <Route
                            path="/reports/health"
                            element={<Protector><HealthReport /></Protector>}
                            sensitive
                        />

                        <Route
                            path="/reports/rag"
                            element={<Protector><RagDashboard /></Protector>}
                            sensitive
                        />

                        {
                            this.props.contractTemplate.workflowGroups.map(workflowGroupItem =>
                                workflowGroupItem.workflows.map(workflowItem => {
                                    const DynoComp = require('../../contract/' + workflowGroupItem.path + '/' + workflowItem.config.paths.base).default;
                                    const globalResourcesOverriden = TemplateHelper.getGlobalResourcesOverriden(this.props.contractTemplate.resources, workflowItem);

                                    return (
                                        <Route
                                            key={workflowItem.id}
                                            sensitive
                                            path={workflowItem.paths.routerMatch}
                                            element={
                                                <DynoComp
                                                    resources={workflowGroupItem.resources}
                                                    placeholders={workflowGroupItem.placeholders}
                                                    placeholdersQA={workflowGroupItem.placeholdersQA}
                                                    workflowsQA={this.props.contractTemplate.workflowsQA}
                                                    workflowItem={workflowItem}
                                                    workflowGroupItem={workflowGroupItem}
                                                    customFields={(this.props.customFields || {})[workflowItem.id]}
                                                    customFieldsCommon={(this.props.customFields || {})[0]}
                                                    globalResources={globalResourcesOverriden}
                                                    accessibleWfIds={this.props.contractTemplate.accessibleWfIds}
                                                    contract={this.props.contract}
                                                    contractUser={this.props.contractUser}
                                                />
                                            }
                                        />
                                    );
                                })
                            )
                        }

                        <Route path="*" element={<NavigateToDefault />} />
                    </Routes>
                    <ContractSidePanel contractid={this.props.params.contractid} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    contractTemplate: store.contract.template,
    contract: store.contract.contract,
    customFields: store.contract.customFields,
    contractUser: store.contract.user,
    contractUsers: store.contract.users,
    contractDashboard: store.contract.dashboard,
    dashboardCurrencyCode: store.contract.dashboardCurrencyCode,
});

const mapDispatchToProps = {
    loadContract: contractDuck.actions.fetchStart,
    unloadContract: contractDuck.actions.logout
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContractRouter));